export default "__VITE_ASSET__zWGzOF8K__"